import DeleteModal from "../components/DeleteModal";
import { deleteBid } from "../clients/finance";

function DeleteBidModal(props) {
  return (
    <DeleteModal
      request={deleteBid}
      id={props.id}
      onClose={props.onClose}
      onDelete={props.onDelete}
      toastMessage="The bid was deleted"
      title="Delete bid?"
      confirmText="DELETE"
      message={
        <p className="m-0">Do you want to delete the bid permanently?</p>
      }
    />
  );
}

export default DeleteBidModal;
